import React from 'react';
import styled from 'styled-components';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  fullWidth?: boolean;
  hasError?: boolean;
}

const InputWrapper = styled.div<{ fullWidth?: boolean }>`
  display: inline-block;
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;

const StyledInput = styled.input<InputProps>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(1.25)};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme, hasError }) => (hasError ? theme.colors.error.main : theme.colors.border)};
  border-radius: ${({ theme }) => theme.shape.borderRadius.medium};
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ theme, hasError }) => (hasError ? theme.colors.error.dark : theme.colors.primary.main)};
    box-shadow: 0 0 0 3px ${({ theme, hasError }) => (hasError ? theme.colors.error.light : theme.colors.primary.light)}30;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.background.paper};
    color: ${({ theme }) => theme.colors.text.disabled};
    cursor: not-allowed;
  }
`;

export const Input: React.FC<InputProps> = ({ fullWidth, ...props }) => {
  return (
    <InputWrapper fullWidth={fullWidth}>
      <StyledInput fullWidth={fullWidth} {...props} />
    </InputWrapper>
  );
};

export default Input; 